const eventcodes=
        {T0006:'PayPal Checkout API',
         T0007:'Website payments standard payment',
          T0200:'General currency conversion.',
          T0000:'General: received payment of a type not belonging to the other T00nn categories.',
          T0003:'Pre-approved payment (BillUser API). Either sent or received.',
          T1107:'Payment refund, initiated by merchant.'
        }
export default eventcodes